<template>
    <IOdometer :value="num" format="( ddd),dd" />
</template>

<script type="text/babel">
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';

export default {
    components: {
        IOdometer
    },
    data() {
        return {
            num: 0
        };
    },
    props: {
        value: {
            type: String,
            default: 0
        }
    },
    mounted() {
        this.num = Number(this.value);
    },
};
</script>